import AjaxForm, { EVENT_ERROR, EVENT_SUCCESS } from "webPage/AjaxForm";
import RecaptchaHelper from "util/RecaptchaHelper";

export default class NewsletterForm {
    constructor($element) {
        this.$element = $element;
        this.$form = this.$element;
        this.enableFormJs = this.enableFormJs.bind(this);

        $(window).on('scroll', this.enableFormJs);
        this.enableFormJs();
    }

    enableFormJs() {
        if ($(window).scrollTop() < ($('body').outerHeight() / 2)) {
            return;
        }

        this.bindEvents();

        $(window).off('scroll', this.enableFormJs);
    }

    bindEvents() {
        RecaptchaHelper.load().then(() => {
            RecaptchaHelper.init(this.$element);

            this.form = new AjaxForm(this.$form, async ($form, formData) => {

                const response = await RecaptchaHelper.validate().then((captcha) => {
                    formData.captcha = captcha;
                    return Ajax.post('eotw-newsletter', 'signup', formData);
                });

                if (response.status !== 'success') {
                    throw response;
                }

                return response;
            });

            this.form.on(EVENT_SUCCESS, (data) => {
                this.$element.find('.js-email').text(this.form.getFormData()['input_1']);
                this.$element.addClass('form-layout--submitted');
            }).on(EVENT_ERROR, (e) => {
                console.trace('error', e);
                this.$form.find('button[type="submit"]').removeClass('btn--loading');
            });
        });
    }
}
